import { makeStyles } from 'tss-react/mui';
import { Box, Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { sharedColors, useSharedStyles } from '../../utilities/Styles';
import { multiClass } from '../../utilities/Extensions';
import Waiting from '../Waiting';
import UploadCSV from '../UploadCSV';
import { BulkErrorDialog } from '../BulkErrorDialog';
import { uploadLocationModalities } from '../../services/locationModality';
import { downloadCsvTemplate } from '../../utilities/Csv';
import { modalityCsvTemplate } from '../../variables/CsvTemplate';

interface UploadModalitiesDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: () => void;
}

const UploadModalitiesDialog = (props: UploadModalitiesDialogProps) => {
  const { classes } = useStyles();
  const sharedClasses = useSharedStyles().classes;

  const [loading, setLoading] = useState(false);
  const [bulkErrorMsg, setBulkErrorMsg] = useState<string | undefined>(
    undefined,
  );
  const [file, setFile] = useState<File | undefined>(undefined);

  useEffect(() => {
    setBulkErrorMsg(undefined);
  }, [file]);

  const uploadFile = () => {
    if (file === undefined) {
      return;
    }

    setLoading(true);

    uploadLocationModalities(file)
      .then(() => {
        toast.success('Modalities are successfully uploaded');
        props.onUpload();
      })
      .catch((err) => {
        toast.error('Modality upload failed.');
        setBulkErrorMsg(err.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth>
      <Waiting open={loading} />
      <DialogTitle className={multiClass([sharedClasses.h6, classes.title])}>
        Upload Modalities
      </DialogTitle>
      <Box component='div'>
        <UploadCSV setParentFile={setFile} />
        <BulkErrorDialog
          open={bulkErrorMsg !== undefined}
          message={bulkErrorMsg || ''}
          onClose={() => setBulkErrorMsg(undefined)}
        />
      </Box>
      <DialogActions className={classes.dialogActions}>
        <Box component='div' className={classes.dialogActionsSpacer}>
          <Button
            onClick={() => downloadCsvTemplate(modalityCsvTemplate)}
            className={sharedClasses.buttonText}
          >
            Download CSV Template for Modalities
          </Button>
        </Box>
        <Button
          variant='contained'
          color={'inherit'}
          onClick={props.onClose}
          className={sharedClasses.buttonText}
        >
          Cancel
        </Button>
        <Button
          onClick={uploadFile}
          variant='contained'
          color='primary'
          className={sharedClasses.buttonText}
          disabled={file === undefined}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    color: sharedColors.gray6,
  },
  tabsContainer: {
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(1),
    background: sharedColors.gray1,
  },
  tabLabel: {
    textTransform: 'none',
    fontWeight: 500,
  },
  dialogActionsSpacer: {
    flexGrow: 1,
    display: 'flex',
  },
  dialogActions: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingBottom: theme.spacing(1.5),
  },
}));

export default UploadModalitiesDialog;
